(function() {
    'use strict';

    angular
        .module('bestaaApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('practice', {
            parent: 'app',
            url: '/practice',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/practice/practice.html',
                    controller: 'PracticeController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();
